import React from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { ReactFlowProvider } from 'reactflow';
import { AutomationBuilderV2 } from '@/app/components/automationV2';
import { ProjectsRouteRoot } from '@/app/containers/Projects/constants';

interface AutomationV2ContainerParams {
  projectId: string;
  templateId?: string;
  automationId?: string;
}

const AutomationV2Container: React.FC = () => {
  const history = useHistory();
  const { projectId, templateId, automationId } = useParams<AutomationV2ContainerParams>();

  const handleSave = () => {
    // Navigate back to automation list
    history.push(`${ProjectsRouteRoot}/${projectId}/settings/automation`);
  };

  const handleCancel = () => {
    // Navigate back to automation list
    history.push(`${ProjectsRouteRoot}/${projectId}/settings/automation`);
  };

  return (
    <div className="min-h-screen">
      <ReactFlowProvider>
        <AutomationBuilderV2
          projectId={(() => {
            const parsed = parseInt(projectId, 10);
            if (isNaN(parsed)) {
              throw new Error(`Invalid projectId: ${projectId}`);
            }
            return parsed;
          })()}
          templateId={templateId}
          automationId={automationId}
          onSave={handleSave}
          onCancel={handleCancel}
          readOnly={false}
        />
      </ReactFlowProvider>
    </div>
  );
};

export default AutomationV2Container;
